// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


export const environment = {
  production: true,
  API_KEY : 'AIzaSyBWSxU23FBdyEVTUNm1O2AM5DNqbqsJNl8',

  firebase: {
    // apiKey: "AIzaSyCJT-qFimuiNNAxtOLAnuH5rPcdFyANxuY",
    // authDomain: "wherework2.firebaseapp.com",
    // databaseURL: "https://wherework2.firebaseio.com",
    // projectId: "wherework2",
    // storageBucket: "wherework2.appspot.com",
    // messagingSenderId: "720839188382",
    // appId: "1:720839188382:web:1db65e5eeef88379"
    // apiKey: "AIzaSyBwMYSfc7ctfM_0CsiZhJyMqYG8j19-MbA",
    // authDomain: "whereworks-734c0.firebaseapp.com",
    // databaseURL: "https://whereworks-734c0.firebaseio.com",
    // projectId: "whereworks-734c0",
    // storageBucket: "whereworks-734c0.appspot.com",
    // messagingSenderId: "8946894490",
    // appId: "1:8946894490:web:b2cd1b4f8862b187"

    apiKey: "AIzaSyBjo_4fNjsl2Z-mGnYA4e2c4aADFo1CkSU",
    authDomain: "where-works.firebaseapp.com",
    databaseURL: "https://where-works.firebaseio.com",
    projectId: "where-works",
    storageBucket: "where-works.appspot.com",
    messagingSenderId: "875397263830",
    appId: "1:875397263830:web:8d4552ff52d362dc"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
